import * as constants from './constants';
import * as g_constants from '../global/constants';

let initialState = {
  featuredListings: [],
  extendedStayListings: [],
  listings: [],
  selectedListing: null,
  selectedListingBookings: [],
  selectedListingCalendars: []
};

export default function BrowseListings(state = initialState, action) {
  switch (action.type) {
    case constants.SET_FEATURED_LISTINGS:
      return Object.assign({}, state, {
        featuredListings: action.data
      })
    case constants.SET_EXTENDED_STAY_LISTINGS:
      return Object.assign({}, state, {
        extendedStayListings: action.data
      })
    case constants.SET_LISTING_LIST:
      return Object.assign({}, state, {
        listings: action.data
      });
    case constants.SET_SELECTED_LISTING:
      return Object.assign({}, state, {
        selectedListing: action.data
      });
    case constants.SET_SELECTED_LISTING_BOOKINGS:
      return Object.assign({}, state, {
        selectedListingBookings: action.data
      })
    case constants.SET_SELECTED_LISTING_CALENDARS:
      return Object.assign({}, state, {
        selectedListingCalendars: action.data
      })
    case g_constants.IMPERSONATE:
    case g_constants.LOGOUT:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
